import { ClientError } from '@tribeplatform/gql-client/lib'
import { Poll } from '@tribeplatform/react-sdk/types'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

import { I18nShape } from '../i18n/types.js'

export function percentage(value: number) {
  return `${Math.round(value * 100)}%`
}

export function isAlreadyVoted(poll: Poll) {
  return !!poll.usersVote?.selectionIds?.length
}

export const onError = (i18n: I18nShape) => (error: ClientError) => {
  const errorMessage = error.response.errors.at(0)?.message
  toast({
    description:
      errorMessage ??
      i18n.$t({
        id: 'Error.UnknownError',
        defaultMessage: 'Something went wrong',
      }),
    status: 'error',
  })
}

export const formatDate = (date: Date) => {
  return date.toLocaleString(undefined, {
    dateStyle: 'medium',
    timeStyle: 'short',
    hour12: false,
  })
}

export function pickKeys<
  TRecord extends Record<string, unknown>,
  TKeys extends keyof TRecord,
>(obj: TRecord, keys: TKeys[]): Pick<TRecord, TKeys> {
  const uniqueKeys = [...new Set(keys)]
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => uniqueKeys.includes(key as TKeys)),
  ) as Pick<TRecord, TKeys>
}
